module.exports = __webpack_public_path__ + "img/LSBBGif.088a22a6.gif";